export default __webpack_public_path__ + "static/media/privacy-policy.9ebe0653.md";